<template>
    <div class="announcements-container">
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead class="sash-main sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('declarations')"/></template>
            <template v-slot:right>
                <div class="export-custom">
                    <v-select class="announ-select" outlined dense :no-data-text="$t('no_data')" :label="$t('type')"
                              @change="fetchAdminAnnouncements" :items="types" item-value="type" item-text="title"
                              v-model="messageType"/>
                    <template v-if="messageType === 'sent'">
                        <div class="scl-ad_announ_search-block">
                            <v-select class="announ-select" outlined dense :no-data-text="$t('no_data')"
                                      :label="$t('role')" :items="roles" item-value="code" item-text="title"
                                      v-model="announceObj.roleType" @change="changeRole"/>
                            <v-select class="announ-select" outlined dense :no-data-text="$t('no_data')"
                                      :label="$t('class')" :items="classes" item-text="classTitle" item-value="id"
                                      v-model="announceObj.classId" @change="fetchAnnouncements"
                                      v-show="announceObj.roleType === 'STUDENT' || announceObj.roleType === 'PARENT'"/>
                            <v-btn color="primary" v-if="announceObj.classId || announceObj.roleType === 'INSTRUCTOR'"
                                   class="full-width" v-text="$t('addDeclaration')"
                                   @click="openAnnouncementModal('create', {})"/>
                        </div>
                    </template>
                </div>
            </template>
        </SuperAdminSchoolHead>

        <SmartTable :schools="announcements" :current-page="currentPage" :page-size="pageSize"
                    :total-elements="announcements.length" :totalPages="totalPages">
            <template v-slot:head>
                <th v-html="$t('title')"/>
                <th v-html="$t('description')"/>
                <th v-html="$t('author')"/>
                <th v-html="$t('date')"/>
                <th v-if="messageType === 'sent'"/>
            </template>

            <template v-slot:body="{item}">
                <td v-html="item['title']"/>
                <td v-html="item['content']"/>
                <td v-html="item['bySuperAdmin'] ? 'Супер-админ' : item['userTitle']"/>
                <td v-html="item['createdAt']"/>
                <td v-if="messageType === 'sent'">
                    {{userProfile.user.id}} - {{item['userId']}}
                    <template v-if="userProfile.user.id === item['userId']">
                        <img src="../../assets/images/icons/pen.svg" class="edit-icon"
                             @click="openAnnouncementModal('update', item)">
                        <TrashIcon @click="deleteItem(item, true)"/>
                    </template>
                </td>
            </template>
        </SmartTable>

        <!--ANNOUNCEMENT MODAL-->
        <v-dialog v-model="announceModal">
            <div class="modal-container modal-style">
                <h4>{{ mode === 'create' ? $t('addDeclaration') : ('edit') }}</h4>
                <v-form ref="announceForm">
                    <v-text-field :rules="required" :label="$t('title')" v-model="announceObj.title" outlined dense/>
                    <v-textarea :rules="required" :label="$t('description')" v-model="announceObj.content" outlined dense/>
                    <div class="btn-actions">
                        <v-btn color="red" @click="closeModal">{{ $t('cancel') }}</v-btn>
                        <v-btn color="green" @click="submitSave">{{ $t('save') }}</v-btn>
                    </div>
                </v-form>
            </div>
        </v-dialog>
<!--        <modal name="announce-modal" height="auto">-->
<!--            <div class="modal-container">-->
<!--                <h4>{{ mode === 'create' ? $t('addDeclaration') : ('edit') }}</h4>-->
<!--                <v-form ref="announceForm">-->
<!--                    <v-text-field :rules="required" :label="$t('title')" v-model="announceObj.title"/>-->
<!--                    <v-text-field :rules="required" :label="$t('description')" v-model="announceObj.content"/>-->
<!--                    <div class="btn-actions">-->
<!--                        <v-btn color="red" @click="closeModal">{{ $t('cancel') }}</v-btn>-->
<!--                        <v-btn color="green" @click="submitSave">{{ $t('save') }}</v-btn>-->
<!--                    </div>-->
<!--                </v-form>-->
<!--            </div>-->
<!--        </modal>-->

        <!--DELETE MODAL-->
        <v-dialog v-model="deleteModal">
            <div class="modal-container">
                <h4>{{ $t('remove') }}?</h4>
                <div class="btn-actions">
                    <v-btn color="primary" @click="deleteModal=false">{{ $t('cancel') }}</v-btn>
                    <v-btn color="red" @click="deleteItem('','')">{{ $t('remove') }}</v-btn>
                </div>
            </div>
        </v-dialog>
<!--        <modal name="delete-modal" width="500" height="165">-->
<!--            <div class="modal-container">-->
<!--                <h4>{{ $t('remove') }}?</h4>-->
<!--                <div class="btn-actions">-->
<!--                    <v-btn color="primary" @click="toggleDeleteModal">{{ $t('cancel') }}</v-btn>-->
<!--                    <v-btn color="red" @click="deleteItem('','')">{{ $t('remove') }}</v-btn>-->
<!--                </div>-->
<!--            </div>-->
<!--        </modal>-->
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import SchoolClassService from '@/_services/school-class.service'
import PreLoader from '@/components/preloader/PreLoader'
import AnnouncementService from '@/_services/announcement.service'
import TrashIcon from '@/components/icons/TrashIcon'

export default {
  components: {
    SuperAdminSchoolHead,
    SmartTable,
    PreLoader,
    TrashIcon
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    pageSize () {
      return this.announcements.length === 0 ? 1 : this.announcements.length
    }
  },
  data () {
    return {
      announceModal: false,
      deleteModal: false,
      required: [v => !!v || this.$t('required')],
      types: [
        { title: this.$t('outgoing'), type: 'sent' },
        { title: this.$t('inbox'), type: 'inbox' }
      ],
      roles: [
        { title: this.$t('teacher'), code: 'INSTRUCTOR' },
        { title: this.$t('student'), code: 'STUDENT' },
        { title: this.$t('parent'), code: 'PARENT' }
      ],
      announceObj: {
        bySuperAdmin: false,
        classId: '',
        content: '',
        roleType: '',
        schoolId: 0,
        title: '',
        userId: 0
      },
      messageType: '',
      totalPages: 1,
      currentPage: 1,
      mode: '',
      isLoading: false,
      classes: [],
      announcements: []
    }
  },
  mounted () {
    this.types = [
      { title: this.$t('outgoing'), type: 'sent' },
      { title: this.$t('inbox'), type: 'inbox' }
    ]
    this.roles = [
      { title: this.$t('teacher'), code: 'INSTRUCTOR' },
      { title: this.$t('student'), code: 'STUDENT' },
      { title: this.$t('parent'), code: 'PARENT' }
    ]
  },
  created () {
    this.isLoading = true
    this.announceObj.schoolId = this.school.id
    this.announceObj.userId = this.userProfile.user.id
    this.announceObj.roleType = this.roles[0].code
    this.messageType = 'inbox'
    this.getSchoolClasses()
    this.fetchAdminAnnouncements(this.messageType)
  },
  methods: {
    getSchoolClasses () {
      SchoolClassService.getAllBySchool(this.school.id).then((res) => {
        this.classes = res.map((klass) => {
          klass.classTitle = klass.classLevel + klass.classLabel
          return klass
        })
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    fetchAnnouncements () {
      this.announcements = []
      this.isLoading = true
      AnnouncementService.getSchoolAnnouncements(
        this.school.id,
        this.announceObj.roleType,
        this.announceObj.classId
      ).then((res) => {
        if (res._embedded) {
          this.totalPages = res.page.totalPages
          this.currentPage = res.page.number
          this.announcements = res._embedded.announcementResourceList
          this.isLoading = false
        } else {
          this.$toast.error(this.$t('no_data'))
          this.isLoading = false
        }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchAdminAnnouncements (type) {
      this.announcements = []
      if (type === 'inbox') {
        this.isLoading = true
        this.announceObj.roleType = ''
        AnnouncementService.getAllAnnouncementsByRole('ADMIN').then((res) => {
          this.totalPages = res.page.totalPages
          this.currentPage = res.page.number
          if (res._embedded) {
            this.announcements = res._embedded.announcementResourceList
          }
          this.isLoading = false
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    changeRole () {
      this.announceObj.classId = ''
      if (this.announceObj.roleType === 'INSTRUCTOR') {
        this.fetchAnnouncements()
      }
    },

    openAnnouncementModal (mode, announce) {
      if (mode === 'create' && this.announceObj.roleType !== 'INSTRUCTOR' && !this.announceObj.classId) {
        this.$toast.info(this.$t('chooseAClass'))
        return
      }
      this.mode = mode
      if (mode === 'create') {
        this.announceObj.title = ''
        this.announceObj.content = ''
      } else {
        this.announceObj.title = announce.title
        this.announceObj.content = announce.content
        this.announceObj.userId = announce.userId
        this.announceObj.id = announce.id
      }
      // this.$modal.show('announce-modal')
      this.announceModal = true
    },

    closeModal () {
      this.announceModal = false
      // this.$modal.hide('announce-modal')
    },

    submitSave () {
      if (this.$refs.announceForm.validate()) {
        this.isLoading = true
        AnnouncementService[this.mode](this.announceObj).then(() => {
          this.isLoading = false
          this.$toast.success(this.$t('success'))
          this.closeModal()
          this.fetchAnnouncements()
        }).catch((err) => {
          this.isLoading = false
          this.$toast.error(err)
        })
      }
    },

    deleteItem (announce, confirm) {
      if (confirm) {
        this.announceObj.id = announce.id
        this.toggleDeleteModal()
      } else {
        this.isLoading = true
        AnnouncementService.remove(this.announceObj.id).then(() => {
          this.deleteModal = false
          // this.toggleDeleteModal()
          this.$toast.success(this.$t('successDeleted'))
          this.fetchAnnouncements()
        }).catch((err) => {
          this.isLoading = false
          this.$toast.error(err)
        })
      }
    },

    toggleDeleteModal () {
      // this.$modal.toggle('delete-modal')
      this.deleteModal = true
    }
  }
}
</script>

<style lang="scss">
.modal-style{
    min-width: 600px;
}
@media (max-width: 420px) {
    .modal-style{
        min-width: auto;
    }
}
  .announcements-container {
    .select-filter-block {
        margin-left: 30px;
        display: flex;
        align-items: flex-start;
        gap: 8px;
        .v-select {
          max-width: 150px;
        }
      }
      .edit-icon {
        cursor: pointer;
      }
      .delete-icon {
        margin-left: 5px;
      }
  }
</style>
